<template>
    <div class="base_foot">
        <div class="base_div">
            <div class="logo_card">
                <div class="logo_card_content">
                    <img src="../../../assets/footer-icon.png" />
                    <div class="text">
                        中国领先的以心脑专病数字医疗服务为核心的创新公司
                    </div>
                </div>
            </div>
            <div class="qr_code_card">
                <div
                    class="qr_code_item"
                    v-for="(item, index) in list"
                    :key="index"
                >
                    <div class="qr_code_content">
                        <div class="qr_code_name">{{ item.name }}</div>
                        <div class="qr_code_label" v-html="item.label"></div>
                    </div>
                    <img class="qr_code_img" :src="item.img" />
                </div>
            </div>
        </div>
        <div class="beian">
            <span class="beian_left">
                Copyright @ 2022北京智煜健康科技有限公司</span
            >
            药品医疗器械网络信息服务备案：<a :href="imageUrl" target="_blank">(京)网药械信息备字(2022)第00014号</a>&nbsp;&nbsp; 
            <a href="https://beian.miit.gov.cn/" target="_blank">
                京ICP备2021039717号-3
            </a>
            <img src="../../../assets/ba_icon.png" /><span
                @click="go()"
                style="cursor: pointer"
                >京公网安备 11010502048801号</span
            >
        </div>
    </div>
</template>
<script>
import qrcode1 from '../../../assets/qr-code-1.png'
import qrcode2 from '../../../assets/qr-code-2.png'
import qrcode3 from '../../../assets/qr-code-3.png'
import qrcode4 from '../../../assets/qr-code-4.png'

export default {
    name: 'BaseFooter',
    data () {
        return {
            imageUrl: require('@/assets/home_open.jpeg'),
            list: [
                { name: '医阵营App', label: '专科医生聚集地<br/>拓展延伸医价值', img: qrcode1 },
                { name: '心脑院外宝公众号', label: '连接信任的医生<br/>让患者居家有“医靠”', img: qrcode2 },
                { name: '辈宁院外宝公众号', label: '无感监测  全天守护', img: qrcode3 },
                { name: '智煜健康公众号', label: '了解更多企业资讯', img: qrcode4 }
            ]
        }
    },
    methods: {
        go () {
            window.location.href = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048801'
        }
    }
}
</script>
<style>
.base_foot {
    background-color: #382971;
    background-image: url("../../../assets/footer-bg.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center center;
}
.logo_card {
    height: 200px;
    text-align: center;
    font-size: 33px;
    color: #23b4e2;
    font-weight: bold;
}
.logo_card_content {
    padding-top: 73px;
}
.logo_card img {
    width: 268px;
    height: 58px;
}
.logo_card .text {
    margin-top: 17px;
}
.qr_code_card {
    background-image: url("../../../assets/footer-icon02.png");
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 85px 0 79px;
}
.qr_code_item:last-child {
    margin-right: 0;
}
.qr_code_item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 40px;
}
.qr_code_content {
    margin-right: 13px;
}
.qr_code_name {
    font-size: 18px;
    color: #24b5e2;
    font-weight: 500;
}
.qr_code_label {
    font-size: 16px;
    color: #ffffff;
    opacity: 0.6;
    margin-top: 13px;
    height: 40px;
}
.qr_code_img {
    width: 100px;
    height: 100px;
}
.beian {
    background-image: linear-gradient(to right, #289bbd, #6959c9);
    height: 79px;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 79px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.beian_left {
    margin-right: 50px;
}
.beian img {
    width: 20px;
    height: 20px;
    margin: 0 10px 0 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Footer/base-footer.vue